import {
  GET_SCHOOL_DATA_REQUESTED,
  GET_SCHOOL_DATA_SUCCESSFUL,
  GET_SCHOOL_DATA_FAILED,
  GET_SCHOOL_COURSES_REQUESTED,
  GET_SCHOOL_COURSES_SUCCESSFUL,
  GET_SCHOOL_COURSES_FAILED,
  GET_COURSE_MODULES_REQUESTED,
  GET_COURSE_MODULES_SUCCESSFUL,
  GET_COURSE_MODULES_FAILED,
  GET_SOCIALS_REQUESTED,
  GET_SOCIALS_SUCCESSFUL,
  GET_SOCIALS_FAILED,
  GET_FORUMS_REQUESTED,
  GET_FORUMS_SUCCESSFUL,
  GET_FORUMS_FAILED,
  SET_FORUMS_DATA,
  GET_FORUMS_SUMMARY_REQUESTED,
  GET_FORUMS_SUMMARY_SUCCESSFUL,
  GET_FORUMS_SUMMARY_FAILED,
  GET_FORUMS_UNANSWERED_REQUESTED,
  GET_FORUMS_UNANSWERED_SUCCESSFUL,
  GET_FORUMS_UNANSWERED_FAILED,
  SET_FORUMS_UNANSWERED_DATA,
  GET_QUESTION_DATA_REQUESTED,
  GET_QUESTION_DATA_SUCCESSFUL,
  GET_QUESTION_DATA_FAILED,
  SHOW_FORUM_MODAL,
  HIDE_FORUM_MODAL,
  SET_FORUMS_ERROR,
  UPVOTE_FORUM_QUESTION_SUCCESSFUL,
  DOWNVOTE_FORUM_QUESTION_SUCCESSFUL,
  SET_FORUM_ANSWER_LIST,
  SET_FORUM_COMMENT_LIST,
  SET_FORUM_LATEST_LIST,
  SET_FORUM_UNANSWERED_LIST,
  SET_FORUM_QUESTION_DATA,
  SET_FORUM_ANSWER_DATA,
  SET_FORUM_COMMENT_DATA,
  SEARCH_FORUMS_REQUESTED,
  SEARCH_FORUMS_SUCCESSFUL,
  SEARCH_FORUMS_FAILED,
  SEARCH_FORUMS_TAG_REQUESTED,
  SEARCH_FORUMS_TAG_SUCCESSFUL,
  SEARCH_FORUMS_TAG_FAILED,
  GET_SCHOOL_DATA_BY_DOMAIN_REQUESTED,
  GET_SCHOOL_DATA_BY_DOMAIN_SUCCESSFUL,
  GET_SCHOOL_DATA_BY_DOMAIN_FAILED,
} from "./action-types"

const initialState = {
  isLoading: false,
  schoolData: {},
  schoolColor: localStorage.getItem("app-theme"),
  isCoursesLoading: false,
  courses: [],
  error: {},
  isLoadingCourseModules: false,
  courseModules: [],
  isLoadingSocials: false,
  socials: {},
  isLoadingForums: false,
  forums: {},
  isLoadingForumsSummary: false,
  forumsSummary: {},
  isLoadingForumsUnanswered: false,
  forumsUnanswered: {},
  isLoadingQuestionData: false,
  questionData: {},
  forumModal: {
    isShowing: false,
    type: "",
    successType: "",
    errors: "",
    isEdit: false,
  },
}

const schoolReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCHOOL_DATA_REQUESTED:
    case GET_SCHOOL_DATA_BY_DOMAIN_REQUESTED:
      return {
        ...state,
        isLoading: true,
      }
    case GET_SCHOOL_DATA_SUCCESSFUL:
    case GET_SCHOOL_DATA_BY_DOMAIN_SUCCESSFUL:
      localStorage.setItem("schoolLogo", action?.payload?.data?.logo)
      return {
        ...state,
        schoolData: action.payload.data,
        isLoading: false,
      }
    case GET_SCHOOL_DATA_FAILED:
    case GET_SCHOOL_DATA_BY_DOMAIN_FAILED:
      return {
        ...state,
        schoolData: {},
        isLoading: false,
      }
    case GET_SCHOOL_COURSES_REQUESTED:
      return {
        ...state,
        isCoursesLoading: true,
      }
    case GET_SCHOOL_COURSES_SUCCESSFUL:
      return {
        ...state,
        courses: action.payload.data,
        isCoursesLoading: false,
      }
    case GET_SCHOOL_COURSES_FAILED:
      return {
        ...state,
        courses: [],
        isCoursesLoading: false,
      }

    case GET_COURSE_MODULES_REQUESTED:
      return {
        ...state,
        isLoadingCourseModules: true,
      }
    case GET_COURSE_MODULES_SUCCESSFUL:
      return {
        ...state,
        courseModules: action.payload.data,
        isLoadingCourseModules: false,
      }
    case GET_COURSE_MODULES_FAILED:
      return {
        ...state,
        courseModules: [],
        isLoadingCourseModules: false,
      }

    case GET_SOCIALS_REQUESTED:
      return {
        ...state,
        isLoadingSocials: true,
      }
    case GET_SOCIALS_SUCCESSFUL:
      return {
        ...state,
        socials: action.payload.data,
        isLoadingSocials: false,
      }
    case GET_SOCIALS_FAILED:
      return {
        ...state,
        socials: {},
        isLoadingSocials: false,
      }
    case GET_FORUMS_REQUESTED:
      return {
        ...state,
        isLoadingForums: true,
      }
    case GET_FORUMS_SUCCESSFUL:
      return {
        ...state,
        isLoadingForums: false,
      }
    case GET_FORUMS_FAILED:
      return {
        ...state,
        forums: {},
        isLoadingForums: false,
      }
    case SET_FORUMS_DATA: {
      return {
        ...state,
        forums: action.payload,
      }
    }
    case GET_FORUMS_SUMMARY_REQUESTED:
      return {
        ...state,
        forumsSummary: {},
        isLoadingForumsSummary: true,
      }
    case GET_FORUMS_SUMMARY_SUCCESSFUL:
      return {
        ...state,
        forumsSummary: action.payload.data,
        isLoadingForumsSummary: false,
      }
    case GET_FORUMS_SUMMARY_FAILED:
      return {
        ...state,
        forumsSummary: {},
        isLoadingForumsSummary: false,
      }

    case GET_FORUMS_UNANSWERED_REQUESTED:
      return {
        ...state,
        isLoadingForumsUnanswered: true,
      }
    case GET_FORUMS_UNANSWERED_SUCCESSFUL:
      return {
        ...state,
        isLoadingForumsUnanswered: false,
      }
    case GET_FORUMS_UNANSWERED_FAILED:
      return {
        ...state,
        forumsUnanswered: {},
        isLoadingForumsUnanswered: false,
      }
    case SET_FORUMS_UNANSWERED_DATA: {
      return {
        ...state,
        forumsUnanswered: action.payload,
      }
    }
    case GET_QUESTION_DATA_REQUESTED:
      return {
        ...state,
        isLoadingQuestionData: true,
      }
    case GET_QUESTION_DATA_SUCCESSFUL:
      return {
        ...state,
        questionData: action.payload.data,
        isLoadingQuestionData: false,
      }
    case GET_QUESTION_DATA_FAILED:
      return {
        ...state,
        questionData: {},
        isLoadingQuestionData: false,
      }
    case SHOW_FORUM_MODAL:
      return {
        ...state,
        forumModal: {
          showModal: true,
          type: action.payload.type,
          successType: "",
          isEdit: action.payload.isEdit || false,
        },
        errors: {},
      }
    case HIDE_FORUM_MODAL:
      return {
        ...state,
        forumModal: {
          showModal: false,
          type: "",
          successType: "",
          isEdit: false,
        },
        errors: {},
      }
    case SET_FORUMS_ERROR:
      return {
        ...state,
        errors: action.payload,
      }
    case UPVOTE_FORUM_QUESTION_SUCCESSFUL:
      return {
        ...state,
        questionData: {
          ...state.questionData,
          ...action.payload.data,
        },
      }
    case DOWNVOTE_FORUM_QUESTION_SUCCESSFUL:
      return {
        ...state,
        questionData: {
          ...state.questionData,
          ...action.payload.data,
        },
      }
    case SET_FORUM_ANSWER_LIST:
      return {
        ...state,
        questionData: {
          ...state.questionData,
          answers: action.payload,
        },
      }
    case SET_FORUM_COMMENT_LIST:
      return {
        ...state,
        questionData: {
          ...state.questionData,
          comments: action.payload,
        },
      }
    case SET_FORUM_LATEST_LIST:
      return {
        ...state,
        forums: {
          ...state.forums,
          data: action.payload,
        },
      }
    case SET_FORUM_UNANSWERED_LIST:
      return {
        ...state,
        forumsUnanswered: {
          ...state.forumsUnanswered,
          data: action.payload,
        },
      }
    case SET_FORUM_QUESTION_DATA:
      return {
        ...state,
        questionData: action.payload,
      }
    case SET_FORUM_ANSWER_DATA:
      return {
        ...state,
        answerData: action.payload,
      }
    case SET_FORUM_COMMENT_DATA:
      return {
        ...state,
        commentData: action.payload,
      }

    case SEARCH_FORUMS_REQUESTED:
    case SEARCH_FORUMS_TAG_REQUESTED:
      return {
        ...state,
        isLoadingForums: true,
      }
    case SEARCH_FORUMS_SUCCESSFUL:
    case SEARCH_FORUMS_TAG_SUCCESSFUL:
      return {
        ...state,
        isLoadingForums: false,
      }
    case SEARCH_FORUMS_FAILED:
    case SEARCH_FORUMS_TAG_FAILED:
      return {
        ...state,
        forums: {},
        isLoadingForums: false,
      }

    default:
      return state
  }
}

export default schoolReducer
